// Claude: Admin AI KB for Sellers — ai_seller type entries 15-03-2026
import React from "react";
import KnowledgeBasePage from "./KnowledgeBasePage";

const HINT = `To show a tappable button in the AI chat, wrap the option text with <button> tags. Example: <button>Know more about AFTR</button>`;

const AIKnowledgeSellers = () => <KnowledgeBasePage type="ai_seller" title="AI Knowledge Base — Sellers" hint={HINT} />;

export default AIKnowledgeSellers;
